import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { wrapper } from 'ggtmo-utils';
import styled from 'styled-components';

// Components
import RequestAccountForm from './components/RequestAccountForm';
import ModalHeader from '../../../shared/components/ModalHeader';
import ModalContent from '../../../shared/components/ModalContent';

// Redux
import { register } from '../redux/actions';
import { ACCOUNT_REGISTER } from '../redux/actionCreators';

// Utils
import getTimeOfDay from '../../../shared/utils/getTimeOfDay';

const PageWrapper = styled.div`
  position: relative;
  padding: 1rem;
  height: 100vh;
  background-color: #f2f4f7;
`;

const StaticModal = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  width: 40%;
  margin: auto;
  border-radius: 1rem;
`;

class Register extends PureComponent {
  static propTypes = {
    // Router
    history: ReactRouterPropTypes.history.isRequired,

    // Account
    accountActions: PropTypes.instanceOf(Object).isRequired,

    // Actions
    register: PropTypes.func.isRequired,
  };

  handleOnRegister = (values) => {
    const { register: registerUser, history } = this.props;
    return registerUser({
      ...values,
      userType: 'staff',
    })
      .then((action) => {
        if (action.type === ACCOUNT_REGISTER.SUCCESS) {
          history.push('/verify-email/');
        }
        return action;
      });
  };

  render() {
    // Props
    const {
      accountActions: {
        ACCOUNT_REGISTER: registerAction,
      },
    } = this.props;

    return (
      <PageWrapper>
        <StaticModal className="shadow">
          <ModalHeader
            title={`Good ${getTimeOfDay()}, enter some info below to get started`}
            isStatic
          />
          <ModalContent style={{ borderBottomLeftRadius: '1rem' }}>
            <RequestAccountForm
              action={registerAction}

              // Callbacks
              onSubmit={this.handleOnRegister}
            />
          </ModalContent>
        </StaticModal>
      </PageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    actions: accountActions,
  } = state.account;

  return {
    // Account
    accountActions,
  };
};

const mapDispatchToProps = {
  register,
};

export default wrapper({
  component: Register,
  wrappers: [
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
  ],
});
